import { BlobToUint8 } from "@pdfking/blob"
import { Identity, StringToUInt8 } from "@pdfking/tfunc"

import type { StreamInput } from "#public"

import { StreamProcess } from "./StreamProcess"

/**
 * Whatever a caller has, as a stream of bytes.
 *
 * {@link StreamProcess} with the three answers a byte reader gives: encode a
 * string, pass bytes along, read a blob — a BlobArray's bytes parts passed
 * along as they are. Nothing is pulled until somebody
 * iterates this, so handing it a response body is not the same as downloading
 * one — and a blob is only read when the iteration reaches it, which is what
 * keeps a hundred-page merge to one page at a time.
 *
 * @param input - A stream, bytes, something blob-shaped, or a sequence of them
 * @returns AsyncGenerator yielding Uint8Array chunks
 *
 * @example
 * ```ts
 * import { StreamToIterable } from "@pdfking/io"
 *
 * const response = await fetch("https://example.com/file")
 * for await (const chunk of StreamToIterable(response.body)) {
 *   console.log(`Received ${chunk.length} bytes`)
 * }
 *
 * // parts of a body that has not been assembled yet
 * StreamToIterable([["hello "], blob, response])
 * ```
 */
export const StreamToIterable = (input: StreamInput): AsyncGenerator<Uint8Array> =>
  StreamProcess(input, StringToUInt8, Identity, BlobToUint8)
